import { dcFactory } from 'dc';
import { SocialButtonsComponent } from './js/social-buttons.component';

dcFactory.register(SocialButtonsComponent);
